import { observable, action, runInAction, computed } from 'mobx'
import { message } from 'antd'
import { json, get } from '../../../../utils/ajax'
import { isAuthenticated } from '../../../../utils/Session'
import uuid from 'uuid/v4'
import {formatParams,setStore} from '../../../../utils/Utils'

class SpecialToolCatalogManagerStore {

    @observable loading
    @observable carseriesCatalogList
    @observable pagination
    @observable brands
    @observable carSeries
    @observable modal
    @observable brandId
    @observable carSeriesId
    @observable modalOrderingMethod
    @observable content
    @observable annexContentId
    @observable fileList   //上传列表
    @observable systemList   //系统列表
    @observable modalSystem   //显示系统编辑框
    @observable systemForm   //系统form
    @observable carId   //车系ID用于新增系统
    @observable systemId   //系统ID
    @observable page   //用于工具列表翻页
    @observable componentsList   //工具列表
    @observable modalComponents   //显示工具编辑框
    @observable componentsForm   //工具Form
    @observable modalComponentsContent   //显示工具内容编辑框
    @observable componentsContents   //用于存放工具内容
    @observable componentsId   //工具ID
    @observable searchForms   //用于查询
    @observable carseriesId //点击查看目录需要的参数id

    constructor () {
        this.loading = false
        this.carseriesCatalogList = []
        this.pagination = {}
        this.brands = {
            list: [],
            selected: ''
        }
        this.carSeries = {
            list: [],
            selected: ''
        }
        this.modal = 'hide'
        this.brandId = []
        this.carSeriesId = []
        this.modalOrderingMethod = 'hide'
        this.content = ''
        this.annexContentId = ''
        this.fileList = []
        this.systemList = []
        this.modalSystem = 'hide'
        this.systemForm = {}
        this.carId = ''
        this.systemId = ''
        this.page = {}
        this.componentsList = []
        this.modalComponents = 'hide'
        this.componentsForm = {}
        this.modalComponentsContent = 'hide'
        this.componentsContents = []
        this.componentsId = ''
        this.searchForms = {}
        this.carseriesId = ''
    }

    /**调用setStore方法并传入当前this***/
    @action
    setStore = (obj) => {
        setStore(obj, this)
    }

    /**
     * 初始化页面
     */
    @action
    initListPage = async (page) => {
        runInAction(() => {
            this.loading = true
        })
        if (page) {
            page--
        } else if (this.pagination.page) {
            page = this.pagination.page - 1
        } else {
            page = 0
        }
        const res = await get(`${process.env.REACT_APP_API_URL}/onestep/base/customerService/specialTool/carseriesCatalog/list`, {
            page: page,
            size: 10
        })
        if (res && res.status === 0) {
            return
        }
        runInAction(() => {
            this.carseriesCatalogList = res.content
            this.pagination = {
                results: res.size,
                page: res.number + 1,
                total: res.totalElements
            }
            this.loading = false
        })
    }

    /**
     * 初始化品牌下拉框
     */
    @action
    initBrands = async () => {
        runInAction(() => {
            this.loading = true
            this.brands = {
                list: [],
                selected: ''
            }
            this.carSeries = {
                list: [],
                selected: ''
            }
        })
        const res = await json.get(`${process.env.REACT_APP_API_URL}/onestep/base/brand:brandList`)
        if (res && res.status === 0) {
            return
        }
        runInAction(() => {
            this.brands.list = res
            this.loading = false
            this.modal = 'show'
        })
    }

    /**
     * 初始化车系下拉框
     */
    @action
    initCarseries = async (id) => {
        runInAction(() => {
            this.loading = true
        })
        const res = await get(`${process.env.REACT_APP_API_URL}/onestep/base/carseries/list/${id}`)
        if (res && res.status === 0) {
            return
        }
        runInAction(() => {
            this.carSeries.list = res
            this.loading = false
        })
    }

    /**
     * 选中品牌
     */
    @action
    saveBrandId = (value) => {
        runInAction(() => {
            this.brandId = value
        })
    }

    /**
     * 选中车系
     */
    @action
    saveCarSeriesId = (value) => {
        runInAction(() => {
            this.carSeriesId = value
        })
    }

    /**
     * 保存选中的车系和品牌记录
     */
    @action
    saveCatalog = async () => {
        runInAction(() => {
            this.loading = true
        })
        //If NUll
        if (this.brandId.length === 0 || this.carSeriesId.length === 0) {
            message.warning('请选择品牌和车系')
            return
        }
        //获取品牌信息
        let brand = []
        const brandList = this.brands.list
        for (let i = 0; i < brandList.length; i++) {
            if (brandList[i].id === this.brandId) {
                brand = brandList[i]
            }
        }
        //获取车系信息
        let carSeries = []
        const carSeriesList = this.carSeries.list
        for (let i = 0; i < carSeriesList.length; i++) {
            if (carSeriesList[i].id === this.carSeriesId) {
                carSeries = carSeriesList[i]
            }
        }
        //构造
        const data = {
            'carseriesName': carSeries.defaultName,
            'carseriesImage': carSeries.icon,
            'carseriesId': carSeries.id,
            'rank': carSeries.rank,
            'brandName': brand.defaultName,
            'brandId': brand.id,
            'state': 0
        }
        const res = await json.post(`${process.env.REACT_APP_API_URL}/onestep/base/customerService/specialTool/carseriesCatalog/add`, data)
        runInAction(() => {
            if(res.status===1){
                if(res.data==='新增成功'){
                    message.success(res.data)
                }else {
                    message.warning(res.data)
                }
            }
            this.loading = false
            this.modal = 'hide'
        })
        this.initListPage(this.page)
    }

    /**
     * 取消编辑
     */
    @action
    cancelEdit () {
        this.loading = false
        this.modal = 'hide'
    }

    /**
     * 发布/撤销
     */
    @action
    publishByCarseriesId= async (rocord) => {
        runInAction(() => {
            this.loading = true
        })
        const res1 = await json.get(`${process.env.REACT_APP_API_URL}/onestep/base/customerService/specialTool/system/carseriesId/${rocord.carseriesId}`)
        if(res1.length === 0){
            message.warning('该车系下没有系统，请先添加系统！');
            runInAction(() => {
                this.loading = false
            })
            return
        }
        let state = rocord.state ? 0 : 1;
        const res = await json.put(`${process.env.REACT_APP_API_URL}/onestep/base/customerService/specialTool/carseriesCatalog/${rocord.id}/state/${state}`)
        if (res && res.status === 0) {
            message.error('发布失败！');
            return
        }
        if(state === 1){
            message.success('发布成功！');
        }else{
            message.success('撤销成功！');
        }
        runInAction(() => {
            this.loading = false
        })
        this.initListPage(this.page)
    }

    /**
     * 显示订购办法编辑框
     */
    @action
    orderingMethod = async() => {
        runInAction(() => {
            this.loading = true
        })
        const res = await get(`${process.env.REACT_APP_API_URL}/onestep/base/customerService/specialTool/annexContent`)
        this.getFileList(res.id)
        runInAction(() => {
            this.content = res.content
            this.annexContentId = res.id
            this.modalOrderingMethod = 'show'
            this.loading = false
        })
    }

    /**
     * 上传图片
     */
    uploadImage = (blobInfo, success, failure) => {
        const formData = new FormData()
        formData.append('type', 'file')
        formData.append('file', blobInfo.blob())
        fetch(`${process.env.REACT_APP_API_URL}/onestep/base/upload`, {
            method: 'POST',
            headers: {
                Accept: 'application/json',
                'x-access-token': isAuthenticated(),
            },
            body: formData
        }).then(response => {
            return response.text()
        }).then(text => {
            success(text)
        })
    }

    /**
     * 获取富文本编辑框里面的值
     */
    @action
    setFormsContents = (content) => {
        runInAction(() => {
            this.content = content.level.content
        })
    }

    /**
     * 取消订购办法编辑
     */
    @action
    cancelOrderingMethodEdit () {
        this.loading = false
        this.modalOrderingMethod = 'hide'
    }

    /**
     * 新增订购办法 + 修改订购办法
     */
    @action
    saveOrderingMethod = async () => {
        runInAction(() => {
            this.loading = true
        })
        if(!this.annexContentId){
            let search= {
                content : this.content
            }
            await json.post(`${process.env.REACT_APP_API_URL}/onestep/base/customerService/specialTool/annexContent/add`,search)
            runInAction(() => {
                this.modalOrderingMethod = 'hide'
                this.loading = false
            })
        } else {
            let search= {
                id : this.annexContentId,
                content : this.content
            }
            await json.put(`${process.env.REACT_APP_API_URL}/onestep/base/customerService/specialTool/annexContent/update`,search)
            runInAction(() => {
                this.modalOrderingMethod = 'hide'
                this.loading = false
            })
        }
        this.initListPage(this.page)
    }

    /**
     * 上传附件
     */
    @action
    annexUpload = async (info) => {
        runInAction(() => {
            this.loading = false
        })
        if (info.file.status === 'done') {
            await json.post(`${process.env.REACT_APP_API_URL}/onestep/base/customerService/specialTool/annex/add`, {
                otherId: this.annexContentId,
                annexName : info.file.name,
                url : info.file.response
            })
            this.getFileList(this.annexContentId)
            message.success(`${info.file.name} 上传成功`)
            return
        } else if (info.file.status === 'error') {
            message.error(`${info.file.name} 上传失败`)
        }
    }

    /**
     * 删除附件
     */
    @action
    removeUpload = async(id)=>{
        runInAction(() => {
            this.loading = true
        })
        await json.batchDelete(`${process.env.REACT_APP_API_URL}/onestep/base/customerService/specialTool/annex/delete?id=${id}`)
        this.getFileList(this.annexContentId)
        runInAction(() => {
            this.loading = false
        })
    }

    /**
     * 获取上传附件列表
     */
    @action
    getFileList = async (id)=>{
        const res = await get(`${process.env.REACT_APP_API_URL}/onestep/base/customerService/specialTool/annex/list?otherId=${id}`)
        let list = Array.isArray(res) ? res :[]
        runInAction(()=>{
            this.fileList = list
        })
    }

    /**
     * 初始化系统列表
     */
    @action
    initSystem = async(id) => {
        runInAction(() => {
            this.loading = true
        })
        const res = await get(`${process.env.REACT_APP_API_URL}/onestep/base/customerService/specialTool/system/list?carseriesId=${id}`)
        runInAction(()=>{
            this.carId = id
            this.systemList = res
            this.systemId = ''
            this.loading = false
        })
    }

    /**
     * 显示《系统》编辑框
     */
    @action
    showSystem = (flag) => {
        runInAction(() => {
            this.loading = true
            this.modalSystem = flag ? 'show' : 'hide'
            this.loading = false
        })
    }

    /**
     * 《系统》平行化表单，传值给form
     */
    @computed
    get fields() {
        let fields = {
            id: {value: this.systemForm.id},
            name: {value: this.systemForm.name},
        }
        return fields
    }
    /**
     * 将表单对象化，绑值给store。form
     * 系统
     */
    @action
    onEditFieldChange = (changedFields) => {
        const fields = {...this.fields, ...changedFields}
        let systemForm = {
            id: fields.id.value,
            name: fields.name.value,
        }
        this.systemForm = systemForm
    }

    /**
     * 新增系统 + 修改系统
     */
    @action
    saveSystem = async () => {
        runInAction(() => {
            this.loading = true
        })
        if (!this.systemId) {
            let systemForm = {
                name : this.systemForm.name,
                carseriesId : this.carId
            }
            await json.post(`${process.env.REACT_APP_API_URL}/onestep/base/customerService/specialTool/system/add`,systemForm)
            runInAction(() => {
                this.modalSystem = 'hide'
                this.loading = false
            })
            this.initSystem(this.carId)
        } else {
            let systemForm = {
                id : this.systemId,
                name : this.systemForm.name,
                carseriesId : this.carId
            }
            await json.put(`${process.env.REACT_APP_API_URL}/onestep/base/customerService/specialTool/system/update`,systemForm)
            runInAction(() => {
                this.modalSystem = 'hide'
                this.loading = false
            })
            this.initSystem(this.carId)
        }
    }

    /**
     * 取得系统ID
     */
    @action
    obtainSystemId = (id) => {
        runInAction(() => {
            this.systemId = id
        })
    }

    /**
     * 初始化《系统》表单，用于修改系统
     * @param id 根据id查询
     */
    @action
    updateSystem = async () => {
        runInAction(() => {
            this.loading = true
        })
        if(!this.systemId){
            return message.error(`请选择"·系统·"后在修改!`)
        } else {
            const res = await json.get(`${process.env.REACT_APP_API_URL}/onestep/base/customerService/specialTool/system/id/${this.systemId}`)
            if (res && res.status === 0) {
                return
            }
            runInAction(() => {
                this.systemForm = res
                this.loading = false
                this.modalSystem = 'show'
            })
        }
    }

    /**
     * 删除系统
     */
    @action
    deleteSystem = async () => {
        runInAction(() => {
            this.loading = true
        })
        if(!this.systemId){
            return message.error(`请选择"·系统·"后在删除!`)
        } else {
            const res = await json.batchDelete(`${process.env.REACT_APP_API_URL}/onestep/base/customerService/specialTool/system/delete?id=${this.systemId}`)
            if (res && res.status === 0) {
                return
            }
            runInAction(() => {
                this.loading = false
                this.systemId = ''
            })
        }
        this.initSystem(this.carId)
    }

    /**
     * 初始化工具（零件）列表页面
     */
    @action
    initComponentsListPage = async (page) => {
        runInAction(() => {
            this.loading = true
        })
        if (page) {
            page--
        } else if (this.page.page) {
            page = this.page.page - 1
        } else {
            page = 0
        }
        // 构建查询参数
        let search = formatParams({
            name : this.searchForms.name,
            number : this.searchForms.number,
            systemId : this.systemId,
        })
        search.page = page
        const res = await get(`${process.env.REACT_APP_API_URL}/onestep/base/customerService/specialTool/components/list`,search)
        if (res && res.status === 0) {
            return
        }
        runInAction(() => {
            this.componentsList = res.content
            this.page = {
                results: res.size,
                page: res.number + 1,
                total: res.totalElements
            }
            this.loading = false
        })
    }

    /**
     * 显示《工具》编辑框
     */
    @action
    showComponents = (flag) => {
        runInAction(() => {
            this.loading = true
            this.componentsForm = {}
            this.modalComponents = flag ? 'show' : 'hide'
            this.loading = false
        })
    }

    /**
     * 图片上传
     */
    @action
    imageUpload = (info) => {
        runInAction(() => {
            this.loading = true
        })
        if (info.file.status === 'done') {
            info = info.file.response
            runInAction(() => {
                this.loading = false
            })
            return
        } else if (info.file.status === 'error') {
            runInAction(() => {
                this.loading = false
            })
            message.error(`${info.file.name} 上传失败`)
        }
    }

    /**
     * 《工具》清单平行化表单，传值给form
     */
    @computed
    get fieldsComponents() {
        let fieldsComponents = {
            id: {value: this.componentsForm.id},
            number: {value: this.componentsForm.number},
            numbering: {value: this.componentsForm.numbering},
            name: {value: this.componentsForm.name},
            use: {value: this.componentsForm.use},
            image: {value: this.componentsForm.image},
        }
        return fieldsComponents
    }
    /**
     * 将表单对象化，绑值给store。form
     * 工具
     */
    @action
    onEditComponentsFieldChange = (changedFields) => {
        const fieldsComponents = {...this.fieldsComponents, ...changedFields}
        let componentsForm = {
            id: fieldsComponents.id.value,
            number: fieldsComponents.number.value,
            numbering: fieldsComponents.numbering.value,
            name: fieldsComponents.name.value,
            use: fieldsComponents.use.value,
            image: fieldsComponents.image.value,
        }
        this.componentsForm = componentsForm
    }

    /**
     * 用专用工具号查询清单数据
     */
    @action
    inquireComponents = async (number) => {
        runInAction(() => {
            this.loading = true
        })
        const res = await json.get(`${process.env.REACT_APP_API_URL}/onestep/base/customerService/specialTool/list/numberByComponents?number=${number}`)
        if(!res.number){
            runInAction(() => {
                this.componentsForm = res
                this.loading = false
            })
            return message.error(`没有该专用工具号，请重新输入!`)
        } else {
            runInAction(() => {
                this.componentsForm = res
                this.loading = false
            })
        }
    }

    /**
     * 新增工具 + 修改工具
     */
    @action
    saveComponents = async () => {
        runInAction(() => {
            this.loading = true
        })
        if (!this.componentsForm.id) {
            let arrs = this.componentsList.map(item => {
                return item.number
            })
            let arr1 = this.componentsForm.number
            for(let i = 0;i < arrs.length;i++){
                if(arrs[i] === arr1){
                    return message.warning('该专用工具号已存在，请查对后在添加!')
                }
            }
            const res = await json.get(`${process.env.REACT_APP_API_URL}/onestep/base/customerService/specialTool/carseriesCatalog/carseries/id/${this.carId}`)
            let componentsForm = {
                name : this.componentsForm.name,
                image : this.componentsForm.image,
                number : this.componentsForm.number,
                use : this.componentsForm.use,
                numbering : this.componentsForm.numbering,
                systemId : this.systemId,
                carseriesName : res.carseriesName,
                carseriesId : this.carId
            }
            await json.post(`${process.env.REACT_APP_API_URL}/onestep/base/customerService/specialTool/components/add`,componentsForm)
            runInAction(() => {
                this.modalComponents = 'hide'
                this.loading = false
            })
            this.initComponentsListPage(this.systemId,this.page)
        } else {
            await json.put(`${process.env.REACT_APP_API_URL}/onestep/base/customerService/specialTool/components/update`,{
                ...this.componentsForm
            })
            runInAction(() => {
                this.modalComponents = 'hide'
                this.loading = false
            })
            this.initComponentsListPage(this.systemId,this.page)
        }
    }

    /**
     * 初始化表单，可以不传参数，初始化全部为 null
     * @param id 根据id查询
     */
    @action
    modificationComponents = async (id) => {
        runInAction(() => {
            this.loading = true
        })
        const res = await json.get(`${process.env.REACT_APP_API_URL}/onestep/base/customerService/specialTool/components/id/${id}`)
        if (res && res.status === 0) {
            return
        }
        runInAction(() => {
            this.componentsForm = res
            this.loading = false
            this.modalComponents = 'show'
        })
    }

    /**
     * 删除工具
     */
    @action
    deleteComponents = async (id) => {
        runInAction(() => {
            this.loading = true
        })
        const res = await json.batchDelete(`${process.env.REACT_APP_API_URL}/onestep/base/customerService/specialTool/components/delete?id=${id}`)
        if (res && res.status === 0) {
            return
        }
        runInAction(() => {
            this.loading = false
        })
        if(this.componentsList.length === 1){
            await this.initComponentsListPage(this.systemId,this.page.page -1)
        }else{
            await this.initComponentsListPage(this.systemId,this.page.page)
        }
    }

    /**
     * 显示《工具》内容编辑框
     */
    @action
    showComponentsContent = (flag) => {
        runInAction(() => {
            this.loading = true
            this.modalComponentsContent = flag ? 'show' : 'hide'
            this.loading = false
        })
    }

    /**
     * 初始化《工具内容》，可以不传参数，初始化全部为 null
     */
    @action
    initComponentsCatalog = async (record) => {
        runInAction(() => {
            this.componentsId = record.id
            this.componentsContents = []
            this.loading = true
        })
        const res1 = await json.get(`${process.env.REACT_APP_API_URL}/onestep/base/customerService/specialTool/componentsContent/searchOne?componentsId=${record.id}`)
        if(res1.length === 0){
            const res = await json.get(`${process.env.REACT_APP_API_URL}/onestep/base/customerService/specialTool/list/number?number=${record.number}`)
            let componentsContents = await json.get(`${process.env.REACT_APP_API_URL}/onestep/base/customerService/specialTool/listContent/searchOne?listId=${res.id}`)
            componentsContents = componentsContents.map(item => {
                return {
                    id: uuid(),
                    image: item.image,
                    content: item.content,
                    type: item.type,
                    componentsId: record.id
                }
            })
            runInAction(() => {
                this.componentsContents = componentsContents.length ? componentsContents : [{
                    id: uuid(),
                    image: '',
                    content: '',
                    type: 1,
                    componentsId: record.id
                }]
                this.loading = false
            })
            await this.showComponentsContent(true)
        } else {
            runInAction(() => {
                this.componentsContents = res1.length ? res1 : [{
                    id: `${uuid()}`,
                    image: '',
                    content: '',
                    type: 1,
                    componentsId: record.id
                }]
                this.loading = false
            })
            await this.showComponentsContent(true)
        }
    }

    /**
     * 获取到每个编辑器的内容和ID
     */
    @action
    setContent = (id, value) => {
        runInAction(() => {
            this.componentsContents = this.componentsContents.map(item => {
                if (item.id === id) {
                    return {...item, content: value}
                }
                return item
            })
        })
    }

    /**
     * 删除编辑框里的图片
     */
    @action
    delImage = (contentId, imageIndex) => {
        runInAction(() => {
            this.componentsContents = this.componentsContents.map(item => {
                if (item.id === contentId) {
                    return {...item, image: item.image.trim().split(',').filter((img, index) => index !== imageIndex).join(',')}
                }
                return item
            })
        })
    }

    /**
     * 获取到右图左文的内容和ID
     */
    @action
    addContent = (id, type) => {
        const componentsContents = []
        this.componentsContents.forEach(item => {
            componentsContents.push(item)
            if (item.id === id) {
                componentsContents.push({
                    id: `${uuid()}`,
                    image: '',
                    content: '',
                    type: type * 1,
                    componentsId: this.componentsId
                })
            }
        })
        runInAction(() => {
            this.componentsContents = componentsContents
        })
    }

    /**
     * 删除编辑框里的内容
     */
    @action
    delContent = (id) => {
        const componentsContents = this.componentsContents.filter(item => item.id !== id)
        runInAction(() => {
            this.componentsContents = componentsContents.length > 0 ? componentsContents : [{
                id: `${uuid()}`,
                image: '',
                content: '',
                type: 1,
                componentsId: this.componentsId
            }]
        })
    }

    /**
     * 添加图片
     */
    @action
    addImage = (id, url) => {
        runInAction(() => {
            this.componentsContents = this.componentsContents.map(item => {
                if (item.id === id) {
                    return {...item, image: item.image.trim().length > 0 ? `${item.image},${url}` : url}
                }
                return item
            })
        })
    }

    /**
     * 获取ID 用于上移编辑框
     */
    @action
    contentUp = (id) => {
        const index = this.componentsContents.findIndex(item => item.id === id)
        if (index > 0) {
            runInAction(() => {
                this.componentsContents = this.swapItems(this.componentsContents, index, index - 1)
            })
        }
    }

    /**
     * 获取ID 用于下移编辑框
     */
    @action
    contentDown = (id) => {
        const index = this.componentsContents.findIndex(item => item.id === id)
        if(index+1 === this.componentsContents.length){
            return
        }
        if (index >= 0 && index < this.componentsContents.length) {
            runInAction(() => {
                this.componentsContents = this.swapItems(this.componentsContents, index, index + 1)
            })
        }
    }

    swapItems = (arr, index1, index2) => {
        arr[index1] = arr.splice(index2, 1, arr[index1])[0]
        return arr
    }

    /**
     * 新增工具内容
     */
    @action
    saveComponentsContent = async () => {
        runInAction(() => {
            this.loading = true
        })
        await json.post(`${process.env.REACT_APP_API_URL}/onestep/base/customerService/specialTool/componentsContent/add`,this.componentsContents)
        runInAction(() => {
            this.loading = false
        })
        await this.showComponentsContent(false)
    }

    /**
     * 多条件查询
     * 平行化表单，传值给form
     */
    @computed
    get formFields() {
        let formFields = {
            name: {value: this.searchForms.name},
            number: {value: this.searchForms.number},
        }
        return formFields
    }

    /**
     * 多条件查询
     * 将表单时对象化，绑值给store。form
     */
    @action
    onFormChange = (changedFields) => {
        const fields = {...this.formFields, ...changedFields}
        let searchForms = {
            name: fields.name.value,
            number: fields.number.value,
        }
        this.searchForms = searchForms
    }

    /**
     * 重置
     */
    @action
    fieldsReset(){
        runInAction(() => {
            this.loading = true
            this.searchForms = {}
            this.initComponentsListPage(this.systemId,this.page)
            this.loading = false
        })
    }
}
export default new SpecialToolCatalogManagerStore()


// WEBPACK FOOTER //
// ./src/Backend/dongfeng/specialTool/SpecialToolCatalogManager/store.js